export default {
  name: 'PhotoDune',
  abbreviation: 'PD',
  domain: 'photodune.net',
  google_analytics_id: 'UA-11834194-35',
  google_remarketing_label: 'rsMOCJ2EugMQp-WC_AM',
  default_category_view: 'grid',
  ui: {
    item_list_views: [
      {
        value: 'grid',
        label: 'Grid'
      }
    ]
  },
  assets_domains: {
    item_thumbnail: 'thumb-pd.s3.envato.com',
    item_image: 'image-pd.s3.envato.com'
  },
  item_view: {
    footer_link: {
      label: 'Similar images',
      href: '/search?item_id={id}'
    }
  }
}



// WEBPACK FOOTER //
// ./config/sites/photodune.js